import {Component, EventEmitter, Input, Output, OnChanges, OnInit} from '@angular/core';
import {StoreService} from '../../shared';
import {window} from "rxjs/operator/window";

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnChanges, OnInit {

    @Input() id: string;
    @Input() isOpen: boolean;
    @Input() size: string;
    @Output() onClose: EventEmitter<string>;

    constructor(private store: StoreService) {
        this.onClose = new EventEmitter();
        this.size = '';
    }

    ngOnInit() {
        if ( ! ( (this.size === 'modal-sm') || (this.size === 'modal-lg') ) ) {
            this.size = '';
        }
    }

    ngOnChanges(changes) {
        this.updateModalVisibility();
        console.log('qqq =', changes.isOpen);
        console.log('qqq this.isOpen =', this.isOpen);
    }

    onCloseClick() {
        this.isOpen = false;
        this.updateModalVisibility();
        this.onClose.emit(this.id);
    }

    updateModalVisibility() {
        if (this.isOpen) {
            this.store.add('modals', this.id);
            document.querySelector('body').classList.add('modal-open');
            document.querySelector('.modal-backdrop').classList.remove('fade');
            document.querySelector('.modal-backdrop').classList.add('show');
        } else {
            this.store.remove('modals', this.id);
            document.querySelector('body').classList.remove('modal-open');
            document.querySelector('.modal-backdrop').classList.add('fade');
            document.querySelector('.modal-backdrop').classList.remove('show');
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/modal/modal.component.ts